import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import ConfirmAlertModal from "../../Modals/confirmAlertModal";
import { isAlphanumericWithDotSpaceDashCommaBracketsSlash, isNumberRange, isAlphanumericWithSpaceDotDash, checkNull } from "../../../functions/validations";
import { showSuccess, showWarning } from "../../utility/ui/notifications/Toaster";
import SingleValuePopUp from "../../utility/ui/modals/SingleValuePopUp";
import { dateCompare, RenderIf } from "../../../functions/welding-functions";
import { BiSelectMultiple } from "react-icons/bi";
import { AddNewTraining, UpdateTraining } from "../../../Services/training-service";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import ButtonModal from "../../Modals/buttonModal";
import { trainingDate } from "./Training_entity";

const AddEditTrainingMaster = (props) => {
  let action = props.action;
  let formName = "Training";
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const todayDate = yyyy + "-" + mm + "-" + dd;
  const maxDate = yyyy + "-" + `${Number(mm) + +6}` + "-" + dd;
  const minDate = yyyy + "-" + mm + "-" + dd;
  const sixMonthsFromNow = new Date(today);
  sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);

  const lastDayOfSixthMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 6 + 1,
    0
  );
  const sixmonth =
    sixMonthsFromNow > lastDayOfSixthMonth
      ? lastDayOfSixthMonth.toISOString().split("T")[0]
      : sixMonthsFromNow.toISOString().split("T")[0];

  let username = sessionStorage.getItem("UserName");

  const [trainingObj, setTrainingObj] = useState(
    action === "Edit" || action === "Copy"
      ? props.rowdata
      : {
        SK: "",
        PK: "Training",
        wld_trainingSub: "",
        wld_fromDate: todayDate,
        wld_toDate: todayDate,
        wld_startTime: "",
        wld_duration: "",
        wld_endTime: "",
        wld_trainingMonth: "",
        wld_facultyType: "internal",
        wld_faculty: "",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
        wld_facultyEmail: "",
        wld_facultyEmpCode: "",
      }
  );

  const [showSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [facultyType, setFacultyType] = useState(
    //trainingObj.wld_facultyType ? trainingObj.wld_facultyType : "internal"
    "internal"
  );

  const [popUp, setPopUp] = useState({
    name: "",
    type: "",
    key: "",
    value: "",
  });

  const [error, setError] = useState({
    wld_trainingSub: { status: false, message: "" },
    wld_fromDate: { status: false, message: "" },
    wld_toDate: { status: false, message: "" },
    wld_startTime: { status: false, message: "" },
    wld_duration: { status: false, message: "" },
    wld_faculty: { status: false, message: "" },
  });
  useEffect(() => {
    setTrainingObj((prevState) => ({
      ...prevState,
      ["wld_trainingMonth"]: calculateMonth(),
    }));
  }, [trainingObj.wld_fromDate]);

  useEffect(() => {
    setTrainingObj((prevState) => ({
      ...prevState,
      ["wld_endTime"]: calculateEndTime(),
    }));
  }, [trainingObj.wld_startTime, trainingObj.wld_duration]);

  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrainingObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleTimeChange = (value, name) => {
    setTrainingObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (value, name) => {
    let result = false;
    if (name === "wld_toDate" && trainingObj.wld_fromDate != "") {
      result = dateCompare(value, trainingObj.wld_fromDate);
    } else if (name === "wld_fromDate" && trainingObj.wld_toDate != "") {
      result = dateCompare(trainingObj.wld_toDate, value);
    }
    if (result) {
      setError((prev) => ({
        ...prev,
        wld_toDate: {
          status: true,
          message: "To date should be greater than or equal to From date",
        },
      }));
    } else if (trainingObj.wld_toDate != "") {
      setError((prev) => ({
        ...prev,
        wld_toDate: {
          status: false,
          message: "",
        },
      }));
    }

    if (trainingObj.wld_fromDate != "") {
      setError((prev) => ({
        ...prev,
        wld_fromDate: {
          status: false,
          message: "",
        },
      }));
    }

    setTrainingObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setTrainingObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setFacultyType(value);
    setTrainingObj((prevState) => ({
      ...prevState,
      ["wld_faculty"]: "",
      ["wld_facultyEmail"]: "",
      ["wld_facultyEmpCode"]: "",
    }));
  };

  const showPopUp = (name, type, key, value) => {
    setPopUp({ name, type, key, value });
    setTimeout(() => setShowForm(true), 0);
  };

  const setPopUpData = (data) => {
    if (data?.name === "PED User" && data?.result) {
      setTrainingObj((prevState) => ({
        ...prevState,
        wld_faculty: data.result.empshortName || '',
        wld_facultyEmail: data.result.empEmailId || '',
        wld_facultyEmpCode: data.result.empSalCode?.toString() || '',
      }));
    }
  };

  const calculateEndTime = () => {
    if (trainingObj.wld_startTime && trainingObj.wld_duration) {
      let a = trainingObj.wld_startTime.split(":");
      let ans = Number(a[0]) + Number(trainingObj.wld_duration);
      let ansStr = ans.toString(10);
      if (ansStr.length === 1) {
        ans = "0" + ans;
      }
      if (ans > 23) {
        ans = 23;
        a[1] = 59;
      }
      return ans + ":" + a[1];
    } else return "";
  };

  const calculateMonth = (fromDate = null) => {
    const dateToUse = fromDate || trainingObj.wld_fromDate || todayDate;
    if (dateToUse) {
      let today = new Date(dateToUse); // yyyy-mm-dd
      let month = today.toLocaleString("default", { month: "short" });
      let year = today.toLocaleString("default", { year: "numeric" });
      return month + " " + year;
    }
    return "";
  };


  const getInitialTrainingObj = () => ({
    SK: "",
    PK: "Training",
    wld_trainingSub: "",
    wld_fromDate: todayDate,
    wld_toDate: todayDate,
    wld_startTime: "",
    wld_duration: "",
    wld_endTime: "",
    wld_trainingMonth: calculateMonth(todayDate),
    wld_facultyType: "internal",
    wld_faculty: "",
    wld_createdby: "",
    wld_createdon: "",
    wld_updatedby: "",
    wld_updatedon: "",
    wld_facultyEmail: "",
    wld_facultyEmpCode: "",
  });

  const resetForm = () => {
    const actions = {
      Add: () => {
        setTrainingObj(getInitialTrainingObj());
        setFacultyType("internal");
      },
      Edit: () => setTrainingObj(props.rowdata),
      Copy: () => {
        setTrainingObj(props.rowdata);
        setFacultyType(props.rowdata.wld_facultyType);
      }
    };

    actions[action]?.();
    setError({
      wld_trainingSub: { status: false, message: "" },
      wld_fromDate: { status: false, message: "" },
      wld_toDate: { status: false, message: "" },
      wld_startTime: { status: false, message: "" },
      wld_duration: { status: false, message: "" },
      wld_faculty: { status: false, message: "" },
    });
  };

  const handleAdd = async () => {
    try {
      let result;
      if (action === "Add" || action === "Copy") {
        trainingObj.wld_createdby = username;
        result = await AddNewTraining(trainingObj);
      } else {
        trainingObj.wld_updatedby = username;
        result = await UpdateTraining(trainingObj);
      }

      if (action === "Edit") {
        showSuccess('Selected Training has been updated successfully');
      }

      if (result.message === "Duplicate") {
        showWarning(result.message);
      } else if (action === "Add" || action === "Copy") {
        showSuccess('Selected Training has been added successfully');
      }
      props.setReload(!props.reload);
      setShowForm(false);
      props.onHide();
    } catch (error) {
      console.error('Error saving training:', error);
    }
  };

  const validateTraining = (restObj) => {
    const newErrors = {};
    let isError = false;

    Object.entries(restObj).forEach(([key]) => {
      if (!trainingObj[key]) {
        isError = true;
        newErrors[key] = { status: true, message: 'This field is required' };
      }
    });

    Object.entries(trainingDate).forEach(([key]) => {
      if (trainingObj[key] > sixmonth) {
        isError = true;
        newErrors[key] = { status: true, message: 'Date should be less than 6 months from today' };
      }
    });

    if (facultyType === "external") {
      trainingObj.wld_facultyEmail = "0";
      trainingObj.wld_facultyEmpCode = "0";
    }

    if (!trainingObj.wld_facultyEmail) {
      isError = true;
      newErrors.wld_faculty = { status: true, message: "Faculty Email is Required" };
    }

    if (action === "Copy" && (trainingObj.wld_fromDate || trainingObj.wld_toDate)) {
      if (dateCompare(trainingObj.wld_fromDate, todayDate)) {
        isError = true;
        newErrors.wld_fromDate = { status: true, message: "From date should be greater than or equal to today date" };
      }
      if (dateCompare(trainingObj.wld_toDate, todayDate)) {
        isError = true;
        newErrors.wld_toDate = { status: true, message: "To date should be greater than or equal to today date" };
      }
    }
    setError(prev => ({ ...prev, ...newErrors }));
    return isError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const hasConflict = props.allRecs.some((existing) => {
      const dateOverlap = (trainingObj.wld_fromDate >= existing.wld_fromDate && trainingObj.wld_fromDate <= existing.wld_toDate) ||
        (trainingObj.wld_toDate >= existing.wld_fromDate && trainingObj.wld_toDate <= existing.wld_toDate);
      const timeOverlap = (trainingObj.wld_startTime >= existing.wld_startTime && trainingObj.wld_startTime < existing.wld_endTime) ||
        (trainingObj.wld_endTime > existing.wld_startTime && trainingObj.wld_endTime <= existing.wld_endTime) ||
        (trainingObj.wld_startTime <= existing.wld_startTime && trainingObj.wld_endTime >= existing.wld_endTime);
      return dateOverlap && existing.wld_faculty === trainingObj.wld_faculty && timeOverlap;
    });

    if (hasConflict) {
      setAlertMessage("Other training already scheduled for selected faculty for selected slot");
      return;
    }

    const { SK, wld_createdby, wld_createdon, wld_updatedby, wld_updatedon, wld_scoreupdated, ...restObj } = trainingObj;
    if (!validateTraining(restObj)) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />

      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} New Training </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2 pb-2">
              <Row style={{ marginBottom: ".5rem" }}>
                <Col md={8} style={{ position: "relative", top: "8px" }}>
                  <div className="g-input w-200">
                    <input
                      type="text"
                      id="wld_trainingSub"
                      name="wld_trainingSub"
                      placeholder=" "
                      style={{ width: "573px" }}
                      maxLength="50"
                      className={
                        error.wld_trainingSub.status ? "err-input" : ""
                      }
                      value={trainingObj.wld_trainingSub}
                      onChange={handleChange}
                      onInput={(e) => {
                        let error =
                          isAlphanumericWithDotSpaceDashCommaBracketsSlash(
                            e.target.value
                          );
                        setError((prevState) => ({
                          ...prevState,
                          wld_trainingSub: error,
                        }));
                      }}
                    />
                    <Form.Label htmlFor="wld_trainingSub">Training Subject</Form.Label>
                  </div>
                  {error.wld_trainingSub.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "8px" }}>
                        {error.wld_trainingSub.message}
                      </span>
                    </Form.Text>
                  )}
                </Col>
                <Col md={4}>
                  <div className="g-input w-100">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          label="From Date"
                          value={
                            trainingObj.wld_fromDate
                              ? dayjs(trainingObj.wld_fromDate)
                              : dayjs(todayDate)
                          }
                          minDate={dayjs(minDate)}
                          maxDate={dayjs(maxDate)}
                          onChange={(newValue) => {
                            let date = dayjs(newValue).format("YYYY-MM-DD");

                            handleDateChange(date, "wld_fromDate");
                          }}
                          format="DD-MM-YYYY"
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  {error.wld_fromDate.status && (
                    <Form.Text className="text-danger">
                      {error.wld_fromDate.message}
                    </Form.Text>
                  )}
                </Col>
              </Row>
              <Row style={{ marginBottom: ".5rem", position: "relative", top: "5px" }}>
                <Col md={4}>
                  <div className="g-input w-100">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          label="To Date"
                          value={
                            trainingObj.wld_toDate
                              ? dayjs(trainingObj.wld_toDate)
                              : dayjs(todayDate)
                          }
                          minDate={dayjs(minDate)}
                          maxDate={dayjs(maxDate)}
                          onChange={(newValue) => {
                            let date = dayjs(newValue).format("YYYY-MM-DD");
                            handleDateChange(date, "wld_toDate");
                          }}
                          format="DD-MM-YYYY"
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  {error.wld_toDate.status && (
                    <Form.Text className="text-danger">
                      {error.wld_toDate.message}
                    </Form.Text>
                  )}
                </Col>
                <Col md={4}>
                  <div className="g-input w-100">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["TimeField"]}>
                        <TimeField
                          label="Start Time"
                          value={
                            trainingObj.wld_startTime
                              ? dayjs(
                                `${todayDate}${trainingObj.wld_startTime}`
                              )
                              : dayjs("2022-04-17T00:00")
                          }
                          onChange={(newValue) => {
                            let time = dayjs(newValue).format("HH:mm");
                            handleTimeChange(time, "wld_startTime");
                          }}
                          onInput={(e) => {
                            let error = checkNull(e.target.value);
                            setError((prevState) => ({
                              ...prevState,
                              wld_startTime: error,
                            }));
                          }}
                          format="HH:mm"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '&.Mui-focused fieldset': {
                                borderColor: 'var(--godrej-purple)',
                              },
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  {error.wld_startTime.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "8px" }}>
                        {error.wld_startTime.message}
                      </span>
                    </Form.Text>
                  )}
                </Col>
                <Col md={4} style={{ position: "relative", top: "8px" }}>
                  <div className="g-input w-100">
                    <input
                      type="text"
                      id="wld_duration"
                      name="wld_duration"
                      placeholder=" "
                      style={{ width: "268px" }}
                      maxLength="1"
                      className={error.wld_duration.status ? "err-input" : ""}
                      value={trainingObj.wld_duration}
                      onChange={handleChange}
                      onInput={(e) => {
                        let error = isNumberRange(e.target.value);
                        setError((prevState) => ({
                          ...prevState,
                          wld_duration: error,
                        }));
                      }}
                    />
                    <Form.Label htmlFor="wld_duration">Duration(hrs)</Form.Label>
                  </div>
                  {error.wld_duration.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "8px" }}>
                        {error.wld_duration.message}
                      </span>
                    </Form.Text>
                  )}
                </Col>
              </Row>
              <Row style={{ marginBottom: "2rem", position: "relative", top: "15px" }}>
                <Col md={4}>
                  <div className="g-input w-100">
                    <input
                      style={{ width: "268px" }}
                      readOnly
                      type="text"
                      id="wld_endTime"
                      name="wld_endTime"
                      placeholder=" "
                      value={
                        action === "Edit"
                          ? trainingObj.wld_endTime
                          : calculateEndTime()
                      }
                    />
                    <Form.Label htmlFor="wld_endTime">End Time</Form.Label>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="g-input w-100">
                    <input
                      style={{ width: "274px" }}
                      readOnly
                      type="text"
                      id="wld_trainingMonth"
                      name="wld_trainingMonth"
                      placeholder=" "
                      value={
                        action === "Edit"
                          ? trainingObj.wld_trainingMonth
                          : calculateMonth()
                      }
                    />
                    <Form.Label htmlFor="wld_trainingMonth">Month of Training</Form.Label>
                  </div>
                </Col>
              </Row>
              <Row style={{ height: "55px" }}>
                <Col md={4}>
                  <div className="m-input">
                    <span>Faculty Type</span>
                    <div className="d-flex mb-2">
                      <div>
                        <input
                          type="radio"
                          name="wld_facultyType"
                          value="internal"
                          checked={facultyType === "internal"}
                          onChange={(e) => handleRadioChange(e)}
                        />
                        <span
                          className={
                            facultyType === "internal"
                              ? "fontWeight ms-2"
                              : "ms-2"
                          }
                        >
                          Internal
                        </span>
                      </div>
                      <div className="ms-5">
                        <input
                          type="radio"
                          name="wld_facultyType"
                          value="external"
                          checked={facultyType === "external"}
                          onChange={(e) => handleRadioChange(e)}
                        />
                        <span
                          className={
                            facultyType === "external"
                              ? "fontWeight ms-2"
                              : "ms-2"
                          }
                        >
                          External
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  {facultyType === "internal" ? (
                    <Form.Group>
                      <div className="d-flex align-items-center">
                        <div className="g-input w-100">
                          <input
                            style={{ width: "274px" }}

                            readOnly
                            id="wld_faculty"
                            name="wld_faculty"
                            type="text"
                            className={
                              error.wld_faculty.status ? "err-input" : ""
                            }
                            placeholder=" "
                            color="var(--col-707070)"
                            value={trainingObj.wld_faculty}
                          />
                          <Form.Label htmlFor="wld_faculty" style={{ position: "absolute" }}>Faculty Name</Form.Label>
                          <BiSelectMultiple
                            size={20}
                            onClick={() => {
                              showPopUp(
                                "PED User",
                                "Single",
                                "emailid",
                                trainingObj.SK
                              );
                            }}
                            color={"gray"}
                            style={{
                              marginLeft: "11.5rem",
                              marginTop: "-4.2rem",
                              position: "relative",
                              left: "45px"
                            }}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  ) : (
                    <div className="g-input w-100">
                      <input
                        type="text"
                        id="wld_faculty"
                        name="wld_faculty"
                        style={{ width: "274px" }}
                        placeholder=" "
                        maxLength="50"
                        className={error.wld_faculty.status ? "err-input" : ""}
                        value={trainingObj.wld_faculty}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithSpaceDotDash(
                            e.target.value
                          );
                          setError((prevState) => ({
                            ...prevState,
                            wld_faculty: error,
                          }));
                        }}
                      />
                      <Form.Label htmlFor="wld_faculty" style={{ position: "absolute" }}>Faculty Name</Form.Label>
                    </div>
                  )}
                  {error.wld_faculty.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "30px" }}>
                        {error.wld_faculty.message}
                      </span>
                    </Form.Text>
                  )}
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>

          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>

          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>

      <RenderIf isTrue={popUp.type === "Single" && showForm}>
        <SingleValuePopUp
          show={showForm}
          onHide={() => setShowForm(false)}
          setSelected={setPopUpData}
          masterName={popUp.name}
          paramkey={popUp.key}
          paramvalue={popUp.value}
          backdrop="static"
        />
      </RenderIf>


    </>
  );
};

export default AddEditTrainingMaster;
